document.addEventListener('click', function (e) {
  var q = e.target.closest('[data-q]');
  if (q) {
    var inp = q.parentNode.querySelector('input');
    var v = parseInt(inp.value) || 1;
    inp.value = q.dataset.q === '+' ? Math.min(v + 1, 99) : Math.max(v - 1, 1);
  }

  /* Bildgeführte Größenwahl: Klick auf eine Produktkachel wählt die Variante */
  var pick = e.target.closest('[data-pick]');
  if (pick) {
    if (pick.getAttribute('aria-disabled') === 'true') return;
    var radio = document.querySelector('.size input[name="id"][value="' + pick.dataset.pick + '"]');
    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

function olSyncPicks(id) {
  document.querySelectorAll('[data-picks] .gpick').forEach(function (b) {
    var on = b.dataset.pick === String(id);
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

document.addEventListener('change', function (e) {
  if (e.target.matches('.size input')) {
    var box = e.target.closest('[data-sizes]');
    box.querySelectorAll('.size').forEach(function (l) {
      l.classList.toggle('is-on', l.contains(e.target));
    });
    var form = e.target.closest('form');
    var btn = form && form.querySelector('[data-add]');
    if (btn && e.target.dataset.price) {
      btn.textContent = 'In den Warenkorb · ' + e.target.dataset.price;
    }
    var src = e.target.dataset.img;
    if (src) {
      var main = document.querySelector('[data-main] img');
      if (main) { main.src = src; main.removeAttribute('srcset'); }
    }
    olSyncPicks(e.target.value);
  }
});

/* Warenkorb: "Zurück" führt auf die Seite, von der man kam (wenn sie zum Shop gehört) */
document.addEventListener('click', function (e) {
  var z = e.target.closest('[data-zurueck]');
  if (!z) return;
  try {
    var r = document.referrer ? new URL(document.referrer) : null;
    if (r && r.origin === location.origin && r.pathname.indexOf('/cart') !== 0 && history.length > 1) {
      e.preventDefault();
      location.href = r.href;
    }
  } catch (err) {}
});
